import React from 'react';
import { Route } from 'react-router-dom';

const BareLayout = (props) => {
  const { component: Component, ...rest } = props;

  return (
    <Route
      {...rest}
      render={matchProps => (
        <div className="page-content">
          <Component {...matchProps} />
        </div>
      )}
    />
  );
};

export default BareLayout;
